enum BillingModuleApiSuffixModels {
  BILLING_FINANCIAL_YEAR = 'financial-years',
  BILLING_FINANCIAL_MONTHS_EnableDisable = 'financialmonths',
  BIILING_TEST_RUN_CONFIGURATION = 'test-run-config',
  BIILING_TEST_RUN_CONFIGURATION_ENABLE = 'run-date-config',
  UX_TEST_RUN_PEROID = "ux/testrun-periods",
  UX_VALIDITY_PERIODS = 'ux/validity-periods',
  BILL_RUN_DATE = "run-date-config/bill-run-date",
  BILL_RUN_DATE_DETAILS = "rundate-financialyear-details",
  BILL_RUN_DATE_CONFIGURATION_BULK_INSERT = "run-date-config/bulkInsert",
  RUN_DATE_CONFIG = "run-date-config",
  BILL_RUN_DATE_CONFIGURATION = "run-date-config",
  MERCANTILE_USER_CODE = 'division-user-code',
  BILLING_INTERVALS = 'billing-intervals',
  DEBIT_ORDER_REJECTIONCODE = 'debit-order-rejection-code',
  DEBIT_ORDER_REJECTIONCODE_INSERT = 'debit-order-rejection-code/bulkinsert',
  CRM_ERROR_CODE = 'crm-error-code',
  CRM_ERROR_CODE_INSERT = 'crm-error-code/bulkinsert',
  UNPAID_REASON_CODE = 'unpaid-reason-code',
  UNPAID_REASON_CODE_INSERT = 'unpaid-reason-code/bulkinsert',
  RUN_CUT_OFF_TIME = 'run-cutoff-time',
  BILLING_CHARGE = "billing-Charge",
  BILLING_CHARGE_DETAIL = "billing-charge-detail",
  UX_SUBSCRIPTIONS = 'ux/subscriptions',
  SUBSCRIPTIONS = 'subscriptions',
  DAILY_TEST_RUN = "daily-test-run",
  DAILY_TEST_RUN_DETAILS = "daily-test-run-details",
  DAILY_TEST_RUN_DETAILS_LIST = "daily-test-run-details-list",
  DAILY_TEST_RUN_LIST_EXPORT = "daily-test-run-list-export",
  WEEKLY_TEST_RUN = "weekly-test-run",
  WEEKLY_TEST_RUN_DETAILS = "weekly-test-run-details",
  WEEKLY_TEST_RUN_DETAILS_LIST = "weekly-test-run-details-list",
  WEEKLY_TEST_RUN_LIST_EXPORT = "weekly-test-run-list-export",
  MONTHLY_TEST_RUN = "monthly-test-run",
  MONTHLY_TEST_RUN_POST = "monthly-test-run/post-monthly-test-run",
  MONTHLY_TEST_RUN_DETAILS = "monthly-test-run-details",
  MONTHLY_TEST_RUN_DETAILS_LIST = "monthly-test-run-details-list",
  MONTHLY_TEST_RUN_LIST_EXPORT = "monthly-test-run-list-export",
  UX_BILLING_INTERVALS = 'ux/billing-intervals',
  UX_PAYMENT_METHODS = 'ux/payment-methods',
  UX_PAYMENT_TYPES = 'ux/payment-types',
  MANUAL_REPOSITORY = 'manual-repository',
  MANUAL_REPOSITORY_DETAILS = 'manual-repository/details',
  MANUAL_REPOSITORY_FILE_UPLOAD = 'manual-repository/files-upload',
  MANUAL_SUB_REPOSITORY = 'manual-repository/sub-repository',
  MANUAL_REPOSITORY_DISABLE_ENABLE = 'manual-repository/enable-disable',
  MANUAL_REPOSITORY_SEARCH = "manual-repository/search",
  MANUAL_REPOSITORY_ACCESS_RIGHTS = "manual-repository/access-rights",
  UX_BILLING_FINANCIAL_YEAR = 'ux/financial-years',
  ERB_BILL_RUN_CONFIG_FINANCIALPERIOD_DETAILS = 'erb-bill-run-config/financialperiod-details',
  FINANCIAL_PERIOD_CONFIGURATION = 'financial-period-configuration',
  BILLING_ADMIN_FEES = 'billing-admin-fees',
  UX_DIVISIONS = 'ux/divisions',
  UX_RUN_DATE_CNFIG_DIVISION = 'ux/run-date-config/divisions',
  LICENSE_TYPE = 'license-types',
  ERB_BILL_RUN_CONFIG = 'erb-bill-run-config',
  ERB_BILL_RUN_CONFIG_DETAILS = 'erb-bill-run-config-details',
  PRO_RATA_FEES = 'prorata-fees',
  PRO_RATA_LICENSE_TYPE = 'ux/license-types',
  PRO_RATA_MONTH = 'ux/prorata-month',
  PRO_RATA_FEES_DETAILS = 'prorata-fees/details',
  STANDARD_TAX = 'tax/standard-tax',
  STOCK_ID = 'stock-id',
  UX_STOCK_ID_TYPE_OF_SERVICE = 'ux/stock-id-typeofservice',
  STOCK_ID_REQUEST = 'stock-id-request',
  UX_GEO_LOCATION_CODE = 'ux/geo-location-code',
  UX_CNGL_LOCATION = 'ux/credit-note-geolocation',
  UX_PC = 'ux/profit-center',
  UX_STOCK_ID = 'ux/stock-id',
  UX_DISTRICTS = 'ux/districts',
  SAMEDAY_TEST_RUN = 'SameDay-TestRun',
  UX_SAMEDAY_TEST_RUN = 'ux/SameDay-TestRun',
  ANNUAL_NETWORK_FEE = 'annual-network-fee-waiver',
  ANNUAL_NETWORK_FEE_APPROVAL = 'annual-network-fee-waiver-approval-detail',
  ANNUAL_NETWORK_FEE_DISTRICT_MANAGER = 'annual-network-fee-waiver/approval-worklist',
  STOCK_ID_APPROVAL_VIEW = 'stock-id-request',
  STOCK_ID_MAPPING = 'stock-id-mapping',
  LICENSE_BILL_MODE = 'license-bill-mode',
  STOCK_ID_MAPPING_DETAILS = 'stock-id-mapping-details',
  STOCK_ID_APPROVAL = 'stock-id-approval',
  FINANCIAL_YEARS = 'ux/financial-years',
  UX_LICENSE_TYPE = 'ux/license-types',
  STOCK_ID_DAY_CONFIG = 'stockid-day-configs',
  STOCK_ID_GRADE_CONFIG = 'stockid-grade-configs',
  STOCK_ID_HOUR_CONFIG = 'stockid-hour-configs',
  STOCK_ID_SHIFT_CONFIG = 'stockid-shift-configs',
  INVOICE_TRANSACTION_TYPES = 'invoice-transaction-types',
  INVOICE_TRANSACTION_DESCRIPTION = 'invoice-transaction-descriptions',
  INVOICE_TRANSACTION_SUBTYPES = 'invoice-transaction-description-subtypes',
  UX_DAY_CONFIG = 'ux/stockid-day-configs',
  UX_HOUR_CONFIG = 'ux/stockid-hour-configs',
  UX_GRADE_CONFIG = 'ux/stockid-grade-configs',
  UX_SHIFT_CONFIG = 'ux/stockid-shift-configs',
  UX_TRANSACTION_TYPES = 'ux/invoice-transaction-types',
  UX_TRANSACTION_DESCRIPTION = '/ux/invoice-transaction-descriptions',
  INVOICE_TRANSACTION_DESCRIPTION_DOCUMENT_DISABLE = 'invoice-transaction-description-documents',
  INVOICE_TRANSACTION_DESCRIPTION_DOCUMENT_SUBTYPE_DISABLE = 'invoice-transaction-description-subtype-documents',
  PRICE_INCREASE_RUN_DATE_CONFIG = 'price-increase-rundate-configs',
  UX_PRICE_INCREASE_RUN_DATE_CONFIG_DIVISION = 'ux/price-increase-rundate-configs/divisions',
  PRICE_INCREASE_RUN_DATE_CONFIG_DETAILS = 'price-increase-rundate-configs/details',
  UX_PRICE_INCREASE_APPROVING_TIME_LIMIT = 'ux/price-increase-rundate-configs/approving-time-limit',
  SAMEDAY_TEST_RUN_SCHEDULE = 'SameDay-TestRun-schedule',
  PRICING_CONFIG_SITE_TYPES = 'pricing-config-site-types',
  PRICING_CONFIG_SERVICE_CATEGORY = 'price-increase-config-services',
  PRICING_INCREASE_EXCLUSIONS = 'price-increase-config-exclusions',
  PRICING_INCREASE_MONTHS = 'price-increase-config-months',
  WORKFLOW_CONFIG = '/escalation-work-flow',
  STATEMENT_CONFIG = '/statement-fee-config',
  STATMENT_DISCOUNT_FEE = '/changing-payment-method-Approval',
  ESCALATION = 'escalations',
  UX_CATEGORY = 'ux/categories',
  UX_SUBCATEGORY = 'ux/sub-categories',
  CATEGORY = 'categories',
  SUB_CATEGORIES = 'sub-categories',
  ORIGIN = 'origins',
  INSTALL_ORIGIN = 'install-origins',
  DEBTOR_GROUP = 'debtor-group',
  SUB_CATEGORY = 'categories/sub-type',
  CATEGORY_TYPE = 'ux/category-type',
  QUALITY_CHECKS = 'quality-checks',
  QUALITY_CHECKS_DETAILS = 'quality-checks-details',
  CUSTOMER_ADDRESS_QUALITY_CHECK = 'quality-checks/customeraddress',
  CUSTOMER_ADDRESS_QUALITY_CHECK_UPDATE = 'quality-checks/customeraddress-review',
  QUALITY_CHECKS_CUSTOMER_CONTACT = 'quality-checks/CustomerConact',
  QUALITY_CHECKS_CUSTOMER_CONTACT_REVIEW = 'quality-checks/customerconact-review',
  QUALITY_CHECKS_KEYHOLDER = 'quality-checks/keyholder',
  QUALITY_CHECKS_KEYHOLDER_REVIEW = 'quality-checks/keyholder-review',
  SITE_INFO_VIEW = 'quality-checks/site-info',
  QUALITY_CHECKS_DEBTOR = 'quality-checks/debtor',
  QUALITY_CHECKS_DEBTOR_REVIEW = 'quality-checks/debtor-review',
  QUALITY_CHECKS_PAYMENT = 'quality-checks/payment',
  QUALITY_CHECKS_PAYMENT_REVIEW = 'quality-checks/payments-review',
  QUALITY_CHECKS_APPROVAL_NOTE = 'quality-checks/approver-notes-review',
  QUALITY_CHECKS_APPROVAL_NOTE_VIEW = 'quality-checks/approver-notes',
  ADHOC_PRICE_INCREASE = 'adhoc-price-increase-stockids',
  SITE_INFO_REVIEW = 'quality-checks/site-info-review',
  ACCESS_TO_PREMISE_REVIEW = 'quality-checks/access-premise-review',
  ACCESS_TO_PREMISE_VIEW = 'quality-checks/access-premises',
  PRICING_FILES_NAMES = 'pricing-file-names',
  ADHOC_LIST = 'adhoc-price-increase-stockids',
  UX_ESCALATION_STATUS = 'ux/escalations-status',
  ADHOC_EXCLUSION_POST = 'adhoc-price-increase-exclusions',
  ADHOC_EXCLUSION__NAME_DETAILS = 'adhoc-pricing-file-name-details',
  UX_REFERENCE_TABLE = 'ux/reference-table/categories',
  UX_REFERENCE_DATA_TABLE = 'ux/reference-table-data/categories',
  UX_SUB_CATEGORIES_REFERENCE_TABLE = 'ux/reference-table/sub-categories',
  UX_SUB_CATEGORIES_REFERENCE_DATA_TABLE = 'ux/reference-table-data/sub-categories',
  UX_INSTALL_ORIGIN = 'ux/install-origins',
  UX_INSTALL_ORIGIN_REFERENCE_TABLE = 'ux/reference-table/install-origins',
  UX_INSTALL_ORIGIN_REFERENCE_DATA_TABLE = 'ux/reference-table-data/install-origins',
  UX_ORIGIN_REFERENCE_TABLE = 'ux/reference-table/origins',
  UX_ORIGIN_REFERENCE_DATA_TABLE = 'ux/reference-table-data/origins',
  UX_DEBTOR_GROUP_REFERENCE_TABLE = 'ux/reference-table/debtor-group',
  UX_DEBTOR_GROUP_REFERENCE_DATA_TABLE = 'ux/reference-table-data/debtor-group',
  UX_ORIGINS = 'ux/origins',
  UX_DEBTOR_GROUP = 'ux/debtor-group',
  CUSTOMER_CLASSIFICATION = 'customer-classification',
  CUSTOMER_SUB_CLASSIFICATION = 'customer-classification/sub-category',
  BUSINESS_CONFIGURATION_LIST = 'bill-run-date-notification-configs',
  UX_FINANCIAL_PERIOD = 'ux/run-date-config/financial-period',
  BUSINESS_CONFIGURATION_DETAILS = 'bill-run-date-notification-configs/details',
  SELF_HELP_TROUBLESHOOT = 'selfhelp-sytem-type-config',
  SELF_HELP_PORTAL = 'self-help-portal',
  SELF_HELP_ENABLE_DISABLE = 'self-help-portal/enable-disable',
  SELF_HELP_QUETION_ANSWER_CONFIG = 'question-answer-config-list',
  SELF_HELP_QUETION_ANSWER_CONFIG_POST = 'self-help-question-answer-config',
  SELF_HELP_QUETION_ANSWER_CONFIG_DETAILS = 'question-answer-config-details',
  SELF_HELP_QUETIOn_ANSER_DELETE = 'selfhelp-question-answer-config',
  FAULT_DESCRIPTION_SYSTEM_TYPES = 'fault-descriptions/system-types',
  QUETION_ANSWER = 'question-answer',
  MANUAL_INVOICE_TRANSACTION_TYPE_DESCRIPTION = 'manual-invoice/transaction-type-descriptions',
  MANUAL_INVOICE_CUSTOMER_DETAILS = 'manual-invoice/customer-detail',
  UX_DEBIT_ORDER_RUN_CODES = 'ux/debit-order-run-codes',
  TRANSACTION_DESCRIPTION_DOCUMENTS = 'ux/manual-invoice/transaction-description-documents',
  MANUAL_INVOICE_UPLOAD = 'manual-invoice/upload',
  MANUAL_INVOICE = 'manual-invoice',
  MANUAL_INVOICE_APPROVAL_DETAILS = 'manual-invoice/approval-detail',
  MANUAL_INVOICE_APPROVE = 'manual-invoice/approve',
  MANUAL_INVOICE_DECLINE = 'manual-invoice/decline',
  MANUAL_INVOICE_DECLINE_REASON = 'ux/manual-invoice/decline-reason',
  PENDING_TRANSACTION = 'manual-invoice/pending-transaction-summary',
  TRANSACTION = 'manual-invoice/transaction-summary',
  MANUAL_DEVICE_GET_BY_ID = 'manual-invoice/detail',
  SELF_HELP_ORDER_REORDER = 'self-help-Question/reorder',
  PRICING_FILE_NAME_DETAILS = 'pricing-file-name-details',
  UX_EXCLUSION_TYPES = 'ux/exclusion-types',
  ERB_BILLING_INVOICE = 'erb-billing-invoice',
  ERB_BILLING_INVOICE_RESEND_SMS = 'erb-billing-invoice/resend-sms',
  CREDITCARD_EXPIRYDATE_NOTIFICATION = 'credit-card-expiry-date-config',
  CREDITCARD_EXPIRYDATE_NOTIFICATION_DETAILS = 'credit-card-expiry-date-config-details',
  UX_MONTHS = 'ux/months',
  CREDITCARD_EXPIRY_MAINTENANCE = 'credit-card-expiry-maintenance',
  CREDITCARD_EXPIRY_MAINTENANCE_DETAILS = 'credit-card-expiry-maintenance-details',
  CREDITCARD_EXPIRY_MAINTENANCE_SEND_EMAIL = 'credit-card-expiry-maintenance-send-mail',
  CREDITCARD_EXPIRY_MAINTENANCE_SEND_SMS = 'credit-card-expiry-maintenance-send-sms',
  CREDITCARD_EXPIRY_MAINTENANCE_DOCUMENT = 'credit-card-expiry-maintenance-document',
  CREDITCARD_EXPIRY_MAINTENANCE_DOCUMENT_DOWNLOAD = '-document',
  UX_BANK_ACCOUNT_TYPES = 'ux/bank-account-types',
  UX_BANKS = 'ux/banks',
  UX_COMMISSION_CONFIG = 'ux/commision-config',
  UX_BANK_BRANCHES = 'ux/bank-branches',
  UX_CANCEL_REASON_CODES = 'ux/cancel-reason-codes',
  PROFORMA_INVOICE = 'proforma-invoice',
  PROFORMA_INVOICE_SEND_MAIL = 'proforma-invoice/send-mail',
  PROFORMA_INVOICE_EXPORT = 'proforma-invoice/export-excel',
  CHARGE_LIST = 'charge-list',
  MANUAL_SAME_DAY_RUN = 'manual-same-day-run',
  MANUAL_MONTHLY_RUN = 'manual-monthly-run',
  CHARGE_LIST_DETAIL = 'charge-list-detail',
  CHARGE_LIST_TYPES = 'ux/charge-list-types',
  STOCK_ID_TYPE_LIST = 'stockid-types',
  STOCK_CATEGROY_LIST = 'stock-categories',
  STOCK_ID_TYPE_CATEGORY_LIST = 'stockid-type-category-mappings',
  STOCK_ID_TYPE_CATEGORY_DROPDOWN = 'ux/stockid-type-category-mappings',
  STOCK_ID_TYPES = 'ux/stockid-types',
  STOCK_CATEGORIES = 'ux/stock-categories',
  DOWNLOAD_PRICE_INCREASE_FILE = 'escalations/download-price-increase-file',
  ACTIVE_FINANCIAL_PERIODS = 'active-financial-periods',
  DEBI_CHECK = 'debi-check',
  DEBI_CHECK_MANDATE_DETAIL = 'debi-check-mandate-detail',
  DEBI_CHECK_MANDATE_EDIT_DETAIL = 'debi-check-mandate-edit-detail',
  DEBI_CHECK_UPDATE_BRANCH = 'debi-check/update-batch',
  DEBI_CHECK_CANCEL_DETAIL = 'debi-check-cancel-detail',
  DEBI_CHECK_CANCEL = 'debi-check/cancel',
  ANNUAL_NETWORK_FEE_BATCH_LIST = 'annual-network-fee-batch-list',
  ANNUAL_NETWORK_FEE_BATCH_DETAIL_LIST = 'annual-network-fee-batch-detail-list',
  DEBI_CHECK_ADD_CUSTOMER_TO_DEBI_CHECK = 'debi-check/add-customer-to-debi-check',
  CHARGE_LIST_REPORT = 'charge-list-report',
  PROMISE_TO_PAY = 'promise-to-pay',
  DEBI_CHECK_CUSTOMER_DETAIL = 'debi-check/customer-detail',
  PROMISE_TO_PAY_DETAILs = 'promise-to-pay/details',
  CHARGE_LIST_SAME_DAY_RUN_REPORT = 'charge-list-same-day-run-report',
  INVOICE_REPORT = 'invoice-report-list',
  INVOICE_REPORT_EXPORT = 'invoice-report-list-export',
  DEBI_CHECK_RESPONSE_DETAIL = 'debi-check-response-detail',
  ANF_BATCH_APPLY_EXCLUSION = 'anf-batch-apply-exclusion',
  ANF_BATCH_SUBMIT_DO = 'anf-batch-submit-do',
  ANNUAL_NETWORK_FEE_DO_USER = 'annual-network-fee-do-user',
  BACK_DATING_IMPORT_LIST = 'back-dating-import-list',
  UX_INVOICE_TRANSACTION_DESCRIPTION_SUBTYPES = 'ux/invoice-transaction-description-subtypes',
  BACK_DATING = 'back-dating',
  BACK_DATING_IMPORT_DETAILS_LIST = 'back-dating-import-details-list',
  BACK_DATING_DOA_APPROVAL_LIST = 'back-dating-doa-approval-list',
  BACK_DATING_DOA_APPROVAL_INSERT = 'back-dating-doa-approval-insert',
  BACK_DATING_IMPORT_DETAILS = 'back-dating-import-details',
  UX_BACK_DATING_DECLINE_REASONS = 'ux/back-dating-decline-reasons',
  ANNUAL_NETWORK_FEE_STATUS = 'ux/anf-approval-status',
  ANNUAL_NETWORK_FEE_APPROVAL_POST = 'annual-network-fee-waiver/approve',
  DEALER_BILLING_COMMISSIONS = 'dealer-billing-commissions',
  DEALER_INVOICE_PAYMENT_METHOD = 'dealer-invoice-payment-method',
  UX_ENDOF_FINANCIAL_YEARS = 'ux/endof-financial-years',
  PROCESS_TYPE_TRANSACTION_MAPPINGS = 'process-types-transaction-mappings',
  UX_PROCESS_TYPE_TRANSACTION_MAPPINGS_SUBTYPE = 'process-types-transaction-mappings-ux-subtype',
  CREDIT_CONTROLER_NOTIFICATON = "credit-controller-notification",
  CREDIT_CONTROLER_NOTIFICATON_FOLLOW_UP_DETAILS = "credit-controller-notification-follow-up-details",
  PAY_AT_RECONCILIATION = 'payat-reconciliation',
  PAY_AT_RECONCILIATION_LIST_DETAILS = 'payat-reconciliation-list-details',
  PAY_AT_RECONCILIATION_LIST_GROUP_BY_DIVISION = 'payat-reconciliation-list-group-by-division',
  PAY_AT_RECONCILIATION_LIST_DIFFERENCE = 'payat-reconciliation-list-difference',
  UX_STATUS_CREDIT_CONTROLLER_NOTFICATION = '/ux/doa-statuscredit-controller-notification',
  SELF_HELP_TROUBLESHOOT_ENABLE = 'self-help-troubleshoot/enable',
  SMS_COMPONY_BANK = "ux/banks",
  SMS_COMPONY_BANK_NEW  = "ux/company-banks",
  SMS_BANK_BRANCH_CODE = "ux/bank-branches",
  SMS_BANK_BRANCH_CODE_NEW = "ux/company-bank-branch",
  DEALER_CLASSIFICATION_MAPPINGS = 'dealer-classification-mappings',
  UX_DEALER_CLASSIFICATION_MAPPINGS_DEALER_CATEGORY = 'ux/dealer-classification-mappings-dealer-category',
  UX_DEALER_CLASSIFICATION_MAPPINGS_ORIGIN = 'ux/dealer-classification-mappings-dealer-origin',
  UX_DEALER_CLASSIFICATION_MAPPINGS_INSTALL_ORIGIN = 'ux/dealer-classification-mappings-dealer-install-origin',
  CUSTOMER_CLASSIFICATION_DEALER = 'customer-classification-dealer',
  CUSTOMER_CLASSIFICATION_DEALER_DETAILS = 'customer-classification/dealer-details',
  UX_INVOICE_TRANSACTION_TYPE = 'ux/invoice-transaction-types',
  PRORATE_FEES_VALIDATE_DATE = 'prorata-fees/validate-date',
  PAYMENT_TRANSACTION_STOCK_LIST = 'payment-transaction/stock-list',
  UX_CANCEL_REASON = 'ux/tickets-cancellation-reason',
  BOC_TRIGGER_CONFIG = 'balance-of-contract/trigger-config',
  BOC_TRIGGER_INITIATION_DAYS = 'balance-of-contract-trigger-initiation-days',
  UX_CONTRACT_TYPE_SUBURBS = 'ux/contract-type-suburbs',
  UX_CONTRACT_SUBURBS_DEBTORS = 'ux/suburb-debtors',
  MONTHLY_TEST_RUN_DATE_DETAILS = 'monthly-test-run-date-details',
  UX_BACK_DATING_VAT_CODE = 'ux/back-dating-vat-code',
  VALIDATE_UPSELL_PAYMENT_DATE = 'validate-upsell-payment-date',
  PRICE_INCREASE_LETTERS = 'price-increase-letters',
  PRICE_INCREASE_LETTER_DETAILS = 'price-increase-letters-detail',
  PRICE_INCREASE_LETTER_DOWNLOAD= 'price-increase-letters-download',
  PAYMENT_OVERRIDE_SPLIT_TYPES= 'payment-override/split-types',
  RADIO_DECODER = 'radio-decoder',
  UX_RADIO_DECODER_CONTRACTS = 'ux/radio-decoder-contracts',
  RADIO_DECODER_ANF = 'radio-decoder-anf',
  RADIO_DECODER_ANF_APPROVAL = 'radio-decoder-anf-approval',
  UX_RADIO_DECODER_ANF_STATUS = 'ux/radio-decoder-anf/status',
  UX_CUSTOMER_AVAILABLITY = '/ux/customer-availability',
  UX_EMAIL_TEMPLATE= 'ux/email-template',
  FUEL_INCRESS_LETTER_CONFIG= 'fuel-increase-letter-config',
  QUOTATION_PAYMENT_OUTSTANDING = 'quotation-payment-outstandings',
  UX_PAYMENT_STATUS = 'ux/payment-status',
  CUSTOMER_RECENT_OUTSTANDING_INVOICES = 'customer-recent-outstanding-invoices',
  CUSTOMER_DEBIT_ORDER_RUN_CODES = 'ux/customer-debit-order-run-codes',
  DEBTOR_CUSTOMER_TRANSACTIONS='debtor-transactions',
  DEBTOR_CUSTOMER_TRANSACTIONS_LIST='debtor-customer-transactions',
  DEBTOR_TRANSACTIONS_EMAIL ='debtor-transactions-email',
  STOCK_TYPE = 'ux/stock-typesstock-id',
  STOCK_ID_AVAILABILITY_ADDRESS = 'ux/stock-id-availability-for-address',
  STOCK_ID_DESC_AVAILABILITY_ADDRESS ='ux/stock-id-description-availability-for-address',
  TAX_DEFAULT = 'tax/default',
  CASUAL_GUARDING_SERVICE = 'casual-guarding-service',
  CHARGE_LIST_EXPORT = 'charge-list-detail-export',
  CREDIT_CARD_MAINTENANCE_STATUS_DROPDOWN = 'ux/credit-card-expiry-maintenance',
  DAILY_TEST_RUN_REPORTS = 'daily-test-run-list-export',
  MONTHLY_TEST_RUN_REPORTS = 'monthly-test-run-list-export',
  WEEKLY_TEST_RUN_REPORTS = 'weekly-test-run-list-export',
  SAME_DAY_RUN_DETAILS = 'charge-list-same-day-run-report-details',
  SAME_DAY_RUN_DETAILS_LIST = 'charge-list-same-day-run-report-detail-list',
  SAME_DAY_RUN_DETAILS_EXPORT = 'charge-list-same-day-run-report-detail-export',
  SAME_DAY_RUN_LIST_EXPORT = 'charge-list-same-day-run-report-export',
  DIVISION_DISTRICT_LIST = 'Division_District_List',
  PAYMENT_TRANSACTION_TOTAL = 'payment-transaction-total',
  PAYMENT_TRANSACTION_TOTAL_BETA = 'payment-transaction-total-beta',
  EDIT_PENDING_DEBIT_ORDER = "edit-pending-debit-order",
  CREDIT_CONTROLLER_NOTIFICATION_CUSTOMER_OUTSTANDING = "credit-controller-notificationcustomer-outstanding",

}

enum BILLING_MODULE_COMPONENT {
  ANNUAL_NETWORK_FEE="Annual Network Fee",
  ANNUAL_NETWORK_FEE_REQUEST="Annual Network Fee Request",
  STOCK_ID="Stock ID",
  STOCK_ID_REQUEST="Stock ID Request",
  STOCK_ID_CREATION="Stock ID Creation",
  STOCK_ID_APPROVAL="Stock ID Approval",
  STOCK_ID_MAPPING="Stock ID Mapping",
  SAME_DAY_RUN_REPORT="Same Day Run Report",
  STATEMENT_FEE_DISCOUNT="Statement Fee Discount",
  TASKS="Tasks",
  RISK_WATCH_CONFIGURATION="Risk Watch Configuration",
  SERVICE_MAINTENANCE="Service Maintenance",
  E_MAIL_DISTRIBUTION_LIST="E-Mail Distribution List",
  SHIFT_CANCEL_REASON="Shift Cancel Reason",
  SERVICE_MAPPING="Service Mapping",
  RECURRING_BILLING="Recurring Billing",
  DEBICHECK='Debi Check',
  MONTHLY_TEST_RUN='Monthly Test Run',
  PRO_FORMA='Pro Forma',
  BACK_DATING='Back Dating',
  BACK_DATING_DOA='Back Dating DOA',
  CREDIT_CARD_MAINTENANCE='Credit Card Maintenance',
  OVERRIDE_REPORT='Override Report',
  CHARGE_LIST='Charge List',
  LICENSE_BILL_MODE = 'License Bill Mode',
  CONTRACT_QUALITY_CHECKS = "Contract Quality Checks",

}


export { BillingModuleApiSuffixModels, BILLING_MODULE_COMPONENT };



